import React, { useState } from "react";

import { useNavigate } from "react-router-dom";

import API from "../../../services/api";

import {

    Store,

    User,

    Phone,

    MapPin,

    Package,

    IndianRupee,

    Navigation,

    Clock3,

    CheckCircle2,

    Circle,

    Bike,

    Wallet,

    ClipboardList,

    ShieldCheck,

    ChevronRight

} from "lucide-react";

import "./OrderCard.css";

function OrderCard({

    order,

    refresh,

}) {

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    // ==========================================
    // Update Order Status
    // ==========================================

    const updateStatus = async (url) => {

        try {

            setLoading(true);

            const response = await API.put(url);

            if (response.data.success) {

                await refresh();

            }

        }

        catch (error) {

            console.log(error);

            alert(

                error.response?.data?.message ||

                "Something went wrong."

            );

        }

        finally {

            setLoading(false);

        }

    };

    // ==========================================
    // Status Color
    // ==========================================

    const getStatusClass = () => {

        switch (order.status) {

            case "Ready For Pickup":

                return "pending";

            case "Assigned":

            case "Reached Restaurant":

            case "Picked Up":

            case "Out For Delivery":

                return "active";

            case "Delivered":

                return "completed";

            case "Rejected":

                return "cancelled";

            default:

                return "pending";

        }

    };

    // ==========================================
    // Timeline Step
    // ==========================================

    const getCurrentStep = () => {

        switch (order.status) {

            case "Assigned":

                return 1;

            case "Reached Restaurant":

                return 2;

            case "Picked Up":

                return 3;

            case "Out For Delivery":

                return 4;

            case "Delivered":

                return 5;

            default:

                return 0;

        }

    };

    const currentStep = getCurrentStep();

    // ==========================================
    // Order Items Preview
    // ==========================================

    const previewItems =

        order.items?.slice(0, 2) || [];

    const remainingItems =

        (order.items?.length || 0) - previewItems.length;

    // ==========================================
    // Action Button
    // ==========================================

    const renderButton = () => {

        switch (order.status) {

            case "Ready For Pickup":

                return (

                    <button

                        className="hf-order-btn"

                        disabled={loading}

                        onClick={() =>

                            updateStatus(

                                `/delivery/orders/${order._id}/accept`

                            )

                        }

                    >

                        <Bike size={18} />

                        {

                            loading

                                ? "Accepting..."

                                : "Accept Order"

                        }

                    </button>

                );

            case "Assigned":

                return (

                    <button

                        className="hf-order-btn"

                        disabled={loading}

                        onClick={() =>

                            updateStatus(

                                `/delivery/orders/${order._id}/reached`

                            )

                        }

                    >

                        <Navigation size={18} />

                        {

                            loading

                                ? "Updating..."

                                : "Reached Restaurant"

                        }

                    </button>

                );

            case "Reached Restaurant":

                return (

                    <button

                        className="hf-order-btn"

                        disabled={loading}

                        onClick={() =>

                            updateStatus(

                                `/delivery/orders/${order._id}/pickup`

                            )

                        }

                    >

                        <Package size={18} />

                        {

                            loading

                                ? "Updating..."

                                : "Pick Up Order"

                        }

                    </button>

                );

            case "Picked Up":

                return (

                    <button

                        className="hf-order-btn"

                        disabled={loading}

                        onClick={() =>

                            updateStatus(

                                `/delivery/orders/${order._id}/out-for-delivery`

                            )

                        }

                    >

                        <Bike size={18} />

                        {

                            loading

                                ? "Updating..."

                                : "Start Delivery"

                        }

                    </button>

                );

            case "Out For Delivery":

                return (

                    <button

                        className="hf-order-btn"

                        onClick={() =>

                            navigate(

                                `/delivery/verify-otp/${order._id}`

                            )

                        }

                    >

                        <ShieldCheck size={18} />

                        Verify Customer OTP

                    </button>

                );

            case "Delivered":

                return (

                    <button

                        className="hf-order-completed"

                        disabled

                    >

                        <CheckCircle2 size={18} />

                        Delivered Successfully

                    </button>

                );

            default:

                return null;

        }

    };

        return (

        <div className="hf-order-card">

            {/* ==========================================
                Header
            ========================================== */}

            <div className="hf-order-header">

                <div className="hf-order-business">

                    <div className="hf-business-icon">

                        <Store size={24} />

                    </div>

                    <div>

                        <h2>

                            {

                                order.providerSnapshot?.businessName ||

                                "HomeFoods Restaurant"

                            }

                        </h2>

                        <span>

                            Order #

                            {order.orderNumber}

                        </span>

                    </div>

                </div>

                <div

                    className={`hf-order-status ${

                        getStatusClass()

                    }`}

                >

                    {order.status}

                </div>

            </div>

            {/* ==========================================
                Customer
            ========================================== */}

            <div className="hf-customer-card">

                <div className="hf-card-title">

                    <User size={18} />

                    Customer Details

                </div>

                <div className="hf-customer-info">

                    <div className="hf-avatar">

                        <User size={22} />

                    </div>

                    <div className="hf-customer-details">

                        <h3>

                            {

                                order.customerSnapshot?.name ||

                                "Customer"

                            }

                        </h3>

                        <p>

                            <Phone size={15} />

                            {

                                order.customerSnapshot?.phone ||

                                "Not Available"

                            }

                        </p>

                    </div>

                </div>

            </div>

            {/* ==========================================
                Pickup & Drop
            ========================================== */}

            <div className="hf-location-grid">

                <div className="hf-location-card">

                    <div className="hf-location-title">

                        <Store size={18} />

                        Pickup Location

                    </div>

                    <p>

                        {

                            order.providerSnapshot?.address ||

                            "Restaurant Address"

                        }

                    </p>

                    <button

                        className="hf-nav-btn"

                    >

                        <Navigation size={16} />

                        Navigate

                    </button>

                </div>

                <div className="hf-location-card">

                    <div className="hf-location-title">

                        <MapPin size={18} />

                        Delivery Location

                    </div>

                    <p>

                        {

                            order.addressSnapshot?.addressLine1 ||

                            "Customer Address"

                        }

                    </p>

                    <button

                        className="hf-nav-btn"

                    >

                        <Navigation size={16} />

                        Navigate

                    </button>

                </div>

            </div>

            {/* ==========================================
                Order Items
            ========================================== */}

            <div className="hf-items-card">

                <div className="hf-card-title">

                    <ClipboardList size={18} />

                    Order Items

                </div>

                {

                    previewItems.map((item,index)=>(

                        <div

                            key={index}

                            className="hf-item-row"

                        >

                            <span>

                                {

                                    item.name ||

                                    item.foodName ||

                                    "Food Item"

                                }

                            </span>

                            <strong>

                                ×

                                {

                                    item.quantity ||

                                    1

                                }

                            </strong>

                        </div>

                    ))

                }

                {

                    remainingItems > 0 &&

                    (

                        <div className="hf-more-items">

                            +

                            {remainingItems}

                            more item(s)

                        </div>

                    )

                }

            </div>

            {/* ==========================================
                Bottom Summary
            ========================================== */}

            <div className="hf-order-summary">

                <div className="hf-summary-box">

                    <Wallet size={20} />

                    <div>

                        <span>

                            Earnings

                        </span>

                        <h4>

                            ₹

                            {order.deliveryCharge || 0}

                        </h4>

                    </div>

                </div>

                <div className="hf-summary-box">

                    <Package size={20} />

                    <div>

                        <span>

                            Items

                        </span>

                        <h4>

                            {

                                order.items?.length || 0

                            }

                        </h4>

                    </div>

                </div>

                <div className="hf-summary-box">

                    <IndianRupee size={20} />

                    <div>

                        <span>

                            Payment

                        </span>

                        <h4>

                            {

                                order.paymentMethod ||

                                "Online"

                            }

                        </h4>

                    </div>

                </div>

            </div>
                        {/* ==========================================
                Quick Actions
            ========================================== */}

            <div className="hf-order-actions">

                <a

                    href={`tel:${order.customerSnapshot?.phone}`}

                    className="hf-call-btn"

                >

                    <Phone size={18} />

                    Call Customer

                </a>

                <a

                    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(

                        order.addressSnapshot?.addressLine1 ||

                        ""

                    )}`}

                    target="_blank"

                    rel="noopener noreferrer"

                    className="hf-map-btn"

                >

                    <Navigation size={18} />

                    Navigate

                </a>

            </div>

            {/* ==========================================
                Delivery Progress
            ========================================== */}

            <div className="hf-progress-card">

                <div className="hf-card-title">

                    <Bike size={18} />

                    Delivery Progress

                </div>

                <div className="hf-progress">

                    <div

                        className={`hf-step ${

                            currentStep >= 1

                                ? "completed"

                                : ""

                        }`}

                    >

                        {

                            currentStep >= 1

                                ? <CheckCircle2 size={18}/>

                                : <Circle size={18}/>

                        }

                        <span>

                            Accepted

                        </span>

                    </div>

                    <div className="hf-line"></div>

                    <div

                        className={`hf-step ${

                            currentStep >= 2

                                ? "completed"

                                : ""

                        }`}

                    >

                        {

                            currentStep >= 2

                                ? <CheckCircle2 size={18}/>

                                : <Circle size={18}/>

                        }

                        <span>

                            Restaurant

                        </span>

                    </div>

                    <div className="hf-line"></div>

                    <div

                        className={`hf-step ${

                            currentStep >= 3

                                ? "completed"

                                : ""

                        }`}

                    >

                        {

                            currentStep >= 3

                                ? <CheckCircle2 size={18}/>

                                : <Circle size={18}/>

                        }

                        <span>

                            Picked Up

                        </span>

                    </div>

                    <div className="hf-line"></div>

                    <div

                        className={`hf-step ${

                            currentStep >= 4

                                ? "completed"

                                : ""

                        }`}

                    >

                        {

                            currentStep >= 4

                                ? <CheckCircle2 size={18}/>

                                : <Circle size={18}/>

                        }

                        <span>

                            Delivering

                        </span>

                    </div>

                    <div className="hf-line"></div>

                    <div

                        className={`hf-step ${

                            currentStep >= 5

                                ? "completed"

                                : ""

                        }`}

                    >

                        {

                            currentStep >= 5

                                ? <CheckCircle2 size={18}/>

                                : <Circle size={18}/>

                        }

                        <span>

                            Delivered

                        </span>

                    </div>

                </div>

            </div>

            {/* ==========================================
                Main Action
            ========================================== */}

            <div className="hf-main-action">

                {renderButton()}

            </div>

        </div>

    );

}

export default OrderCard;